import React, { useState, useEffect } from "react";
import {
  Table,
  Tag,
  Space,
  Button,
  Modal,
  Form,
  Input,
  Select,
  message,
  Descriptions,
  Card,
  Divider,
  Typography,
  InputNumber,
  Popconfirm,
  Cascader,
  Radio,
  Upload,
  Alert,
} from "antd";
import {
  EditOutlined,
  DeleteOutlined,
  EyeOutlined,
  SearchOutlined,
  DownloadOutlined,
  PlusOutlined,
  UploadOutlined,
} from "@ant-design/icons";
import httpUtil from "../../../../utils/httpUtil";

const { Option } = Select;

const statusExplanation = {
  title: "评价流程说明",
  content: (
    <div>
      <p>
        <strong>1. 学生编辑草稿状态记录</strong> -
        学生可以创建和修改草稿状态的评价记录
      </p>
      <p>
        <strong>2. 学生提交草稿记录</strong> -
        学生提交后记录变为"已提交"状态，等待老师审核
      </p>
      <p>
        <strong>3. 老师审核记录</strong> - 老师审核通过后记录变为"已审核"状态
      </p>
      <p>
        <strong>4. 公示记录</strong> - 审核通过的评价将进入公示期
      </p>
      <p>
        <strong>5. 评价已完成</strong> -
        公示期结束后评价流程完成，记录变为"已完成"状态
      </p>
      <Divider />
      <p>
        <Tag color="gray">草稿</Tag> - 学生可编辑的草稿状态
      </p>
      <p>
        <Tag color="orange">已提交</Tag> - 等待老师审核
      </p>
      <p>
        <Tag color="blue">已审核</Tag> - 老师已审核通过
      </p>
      <p>
        <Tag color="red">已驳回</Tag> - 老师审核未通过
      </p>
      <p>
        <Tag color="purple">申诉中</Tag> - 学生对评价有异议，正在申诉
      </p>
      <p>
        <Tag color="green">已完成</Tag> - 评价记录流程已完成
      </p>
    </div>
  ),
};

export const RecordProcessing = ({ userInfo }) => {
  const [records, setRecords] = useState([]);
  const [filteredRecords, setFilteredRecords] = useState([]);
  const [selectedRecord, setSelectedRecord] = useState(null);
  const [editModalVisible, setEditModalVisible] = useState(false);
  const [detailModalVisible, setDetailModalVisible] = useState(false);
  const [form] = Form.useForm();
  const [searchForm] = Form.useForm();
  const [loading, setLoading] = useState(false);
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewFile, setPreviewFile] = useState(null);
  const [pagination, setPagination] = useState({ current: 1, pageSize: 10 });
  const [open, setOpen] = useState(false);
  const [modalForm] = Form.useForm();
  const [fileList, setFileList] = useState([]);
  const [indicators, setIndicators] = useState([]); // 评价指标数据
  const [comfirmLoading, setComfirmLoading] = useState(false);
  const [addEvaluationRadioValue, setAddEvaluationRadioValue] =
    useState("single");
  const [classes, setClasses] = useState([]);
  const [students, setStudents] = useState([]);
  // 在excel中添加
  const [excelForm] = Form.useForm();
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [excelFileList, setExcelFileList] = useState([]);
  const [errors, setErrors] = useState([]); // 导入错误信息
  const [showExplanation, setShowExplanation] = useState(true);

  //获取所有评价数据
  const getAllEvaluations = () => {
    setLoading(true);
    setPagination({ current: 1, pageSize: 10 });
    const params = { evaluator_id: userInfo.username };
    httpUtil.getEvaluationsByTeacher(params).then((res) => {
      if (res.success) {
        setRecords(res.data);
        setFilteredRecords(res.data);
        setLoading(false);
      }
    });
  };
  //获取教师评级指标
  const getIndicators = () => {
    const parmas = {
      applicant_type: userInfo.role,
    };
    httpUtil.getAllIndicators(parmas).then((res) => {
      if (res.success) {
        setIndicators(formatIndicators(res.data));
      }
    });
  };
  // 格式化指标数据
  const formatIndicators = (data) => {
    const newTree = data.map((item) => ({
      value: item.indicator_id,
      label: item.indicator_name,
      // 存储原始指标信息
      rawData: {
        indicator_id: item.indicator_id,
        indicator_name: item.indicator_name,
      },
      children: item.children.map((child) => ({
        value: child.indicator_id,
        label: child.indicator_name,
        // 存储子指标原始信息
        rawData: {
          indicator_id: child.indicator_id,
          indicator_name: child.indicator_name,
        },
        ...child, // 保留其他属性
      })),
    }));
    return newTree;
  };
  //获取全部班级
  const getAllClass = () => {
    httpUtil.geAllClasses({ username: userInfo.username }).then((res) => {
      if (res.success) {
        const formattedClasses = res.data.map((classItem) => ({
          value: classItem.name, // 使用班级名称作为value
          label: classItem.name, // 使用班级名称作为label
        }));
        setClasses(formattedClasses);
      }
    });
  };
  // 查看班级学生名单
  const getClassStudents = (className) => {
    const parmas = { classCode: className };
    setPagination({ ...pagination, current: 1 });
    httpUtil.getStudentsByClass(parmas).then((res) => {
      if (res.success) {
        const formattedStudents = res.data.map((item) => ({
          student_id: item.student_id,
          name: item.name,
          value: item.student_id,
          label: `${item.name} (${item.student_id})`,
        }));
        setStudents(formattedStudents);
      } else {
        message.error(res.error);
      }
    });
  };

  // 获取数据
  useEffect(() => {
    getAllEvaluations();
    getIndicators();
    getAllClass();
  }, []);

  // 处理状态筛选
  const handleStatusFilter = (value) => {
    if (value === "all") {
      setFilteredRecords(records);
    } else {
      setFilteredRecords(records.filter((record) => record.state === value));
    }
  };

  // 处理搜索
  const handleSearch = (values) => {
    let results = [...records];

    if (values.student_id) {
      results = results.filter((record) =>
        record.student_id.includes(values.student_id)
      );
    }

    if (values.indicator_name) {
      results = results.filter((record) =>
        record.indicator_name.includes(values.indicator_name)
      );
    }

    if (values.state && values.state !== "all") {
      results = results.filter((record) => record.state === values.state);
    }
    setPagination({ current: 1, pageSize: 10 });
    setFilteredRecords(results);
  };

  // 处理编辑
  const handleEdit = (record) => {
    setSelectedRecord(record);
    form.setFieldsValue({
      state: record.state,
      comment: record.comment,
      score:
        record.score === null || record.score === undefined
          ? undefined
          : record.score,
    });
    setEditModalVisible(true);
  };

  // 提交编辑
  const handleEditSubmit = () => {
    const formValues = form.getFieldsValue();
    // 检查数据是否有改动
    const isDataChanged =
      formValues.state !== selectedRecord.state ||
      formValues.score !==
        (selectedRecord.score === null ? undefined : selectedRecord.score) ||
      formValues.comment !== selectedRecord.comment;

    if (!isDataChanged) {
      message.warning("没有检测到任何修改，无需提交");
      return;
    }
    if (
      formValues.score === null ||
      formValues.score === undefined ||
      formValues.score === ""
    ) {
      message.error("请填写评分");
      return;
    }
    if (
      formValues.state === "已审核" &&
      (formValues.score === 0 || formValues.score === "0")
    ) {
      message.error("已审核状态评分不能为0");
      return;
    }

    setLoading(true);

    // 准备请求参数
    const params = {
      evaluator_id: userInfo.username,
      record_id: selectedRecord.record_id,
      updateData: {
        state: formValues.state,
        score: Number(formValues.score) || 0, // 确保转换为数字
        comment: formValues.comment,
      },
    };

    // 调用API更新记录
    httpUtil
      .updateEvaluationByTeacher(params)
      .then((res) => {
        if (res.success) {
          const updatedRecords = records.map((record) =>
            record.record_id === selectedRecord.record_id
              ? { ...record, ...res.data }
              : record
          );

          setRecords(updatedRecords);
          setFilteredRecords(updatedRecords);
          setEditModalVisible(false);
          message.success("评价记录更新成功");
        } else {
          message.error(res.error || "更新失败");
        }
      })
      .catch((err) => {
        console.error("更新评价记录出错:", err);
        message.error("网络错误，更新失败");
      })
      .finally(() => {
        setLoading(false);
      });
  };

  // 处理删除
  const handleDelete = (recordId) => {
    setLoading(true);
    const parmas = {
      record_id: recordId,
      evaluator_id: userInfo.username,
    };
    try {
      httpUtil.deleteEvaluationsByTeacher(parmas).then((res) => {
        console.log(res);
        if (res.success) {
          getAllEvaluations();
          message.success("评价记录删除成功");
        } else {
          message.error("评价记录删除失败");
        }
      });
    } catch (err) {
      message.success("评价记录删除成功");
    } finally {
      setLoading(false);
    }
  };

  // 查看详情
  const handleViewDetail = (record) => {
    let processedMaterial = null;

    try {
      // 只有当 material 存在且是字符串时才尝试解析
      if (record.material && typeof record.material === "string") {
        processedMaterial = JSON.parse(record.material);
      } else {
        processedMaterial = record.material; // 保持原样
      }
    } catch (e) {
      console.error("解析 material 失败:", e);
      processedMaterial = record.material; // 解析失败时保持原样
    }

    const processedRecord = {
      ...record,
      material: processedMaterial,
    };

    setSelectedRecord(processedRecord);
    setDetailModalVisible(true);
  };

  // 表格列定义
  const columns = [
    {
      title: "记录ID",
      dataIndex: "record_id",
      key: "record_id",
      width: 120,
    },
    {
      title: "学号",
      dataIndex: "student_id",
      key: "student_id",
      width: 100,
    },
    {
      title: "学生姓名",
      dataIndex: "student_name",
      key: "student_name",
      width: 100,
    },
    {
      title: "班级",
      dataIndex: "class",
      key: "class",
      width: 80,
    },
    {
      title: "评价类型",
      dataIndex: "indicator_name",
      key: "indicator_name",
      width: 110,
    },
    {
      title: "评分",
      dataIndex: "score",
      key: "score",
      width: 80,
      render: (score) => `${score}分`,
    },
    {
      title: "状态",
      dataIndex: "state",
      key: "state",
      width: 80,
      render: (state) => {
        const colorMap = {
          已提交: "orange",
          已审核: "blue",
          已完成: "green",
          已驳回: "red",
          草稿: "gray",
          申诉中: "purple", // 新增申诉中状态
        };
        return <Tag color={colorMap[state]}>{state}</Tag>;
      },
    },
    {
      title: "申请备注",
      dataIndex: "comment",
      key: "comment",
      width: 120,
      ellipsis: true,
      render: (text) => (
        <div style={{ width: 120, overflow: "hidden" }}>
          <Typography.Text ellipsis={{ tooltip: text || "暂无评语" }}>
            {text || "暂无评语"}
          </Typography.Text>
        </div>
      ),
    },
    {
      title: "评价时间",
      dataIndex: "evaluation_date",
      key: "evaluation_date",
      width: 80,
      render: (date) => (date ? new Date(date).toLocaleDateString() : "-"),
    },
    {
      title: "操作",
      key: "action",
      width: 100,
      render: (_, record) => (
        <Space size={"small"}>
          <Button
            type="link"
            icon={<EyeOutlined />}
            onClick={() => handleViewDetail(record)}
          >
            详情
          </Button>
          <Button
            type="link"
            icon={<EditOutlined />}
            onClick={() => handleEdit(record)}
            disabled={record.state === "已审核" || record.state === "已完成"}
          >
            编辑
          </Button>
          <Popconfirm
            title="确定要删除这条记录吗？"
            onConfirm={() => handleDelete(record.record_id)}
            okText="确定"
            cancelText="取消"
            placement="topRight"
          >
            <Button
              type="link"
              danger
              icon={<DeleteOutlined />}
              disabled={record.state === "已审核" || record.state === "已完成"}
            >
              删除
            </Button>
          </Popconfirm>
        </Space>
      ),
    },
  ];

  // 重置搜索
  const handleReset = () => {
    searchForm.resetFields();
    getAllEvaluations();
  };

  // 打开添加申请Modal
  const showModal = () => {
    setOpen(true);
  };

  // 关闭Modal
  const handleCancel = () => {
    modalForm.resetFields();
    excelForm.resetFields();
    setFileList([]);
    setExcelFileList([]);
    setErrors([]);
    setAddEvaluationRadioValue("single");
    setOpen(false);
  };
  // 提交Modal表单
  const handleOk = () => {
    switch (addEvaluationRadioValue) {
      case "single":
        modalForm.submit();
        break;
      case "excel":
        excelForm.submit();
        break;

      default:
        break;
    }
  };

  // 提交申请
  const handleSubmit = async (values) => {
    // 添加申请时间（使用当前时间）
    const applicationDate = new Date().toISOString();
    const selectedNodes = modalForm.getFieldValue("indicator");
    const selectedIndicator = indicators
      .find((item) => item.value === selectedNodes[0])
      ?.children?.find((child) => child.value === selectedNodes[1]);
    const selectedStudent = students.find((s) => s.value === values.student);
    const formData = new FormData();
    formData.append("comment", values.description);
    formData.append("indicator_id", values.indicator[1]);
    formData.append("indicator_name", selectedIndicator.rawData.indicator_name);
    formData.append("evaluator_id", userInfo.username);
    formData.append("evaluator_name", userInfo.full_name);
    formData.append("student_id", selectedStudent.student_id);
    formData.append("student_name", selectedStudent.name);
    formData.append("state", "已提交");
    formData.append("evaluation_date", applicationDate);

    // 添加所有文件
    fileList.forEach((file) => {
      formData.append("files", file.originFileObj);
    });

    setComfirmLoading(true);
    try {
      httpUtil.submitApplication(formData).then((res) => {
        if (res.success) {
          message.success(`提交成功，共上传${res.data.file_count}个文件`);
          modalForm.resetFields();
          setFileList([]);
          handleCancel();
          getAllEvaluations();
        } else {
          message.error(res.error || "提交失败");
        }
      });
    } catch (err) {
      message.error("网络错误");
    } finally {
      setComfirmLoading(false);
    }
  };

  // 文件上传前的校验
  const beforeUpload = (file) => {
    // 文件类型和大小验证
    const isAllowedType = [
      "image/jpeg",
      "image/png",
      "application/pdf",
    ].includes(file.type);
    const isLt5M = file.size / 1024 / 1024 < 5;

    if (!isAllowedType) {
      message.error("仅支持JPG/PNG/PDF格式");
      return Upload.LIST_IGNORE;
    }
    if (!isLt5M) {
      message.error("文件大小不能超过5MB");
      return Upload.LIST_IGNORE;
    }

    setFileList((prev) => [...prev, file]);
    return false; // 手动上传
  };
  //移除文件
  const onRemove = (file) => {
    setFileList((prev) => prev.filter((f) => f.uid !== file.uid));
  };
  // 文件上传处理
  const handleUploadChange = ({ fileList: newFileList }) => {
    setFileList(newFileList);
  };
  // 预览文件
  const handlePreview = (file) => {
    setPreviewFile(file);
    setPreviewVisible(true);
  };

  // 添加 Excel 上传处理函数
  const handleExcelUpload = async (values) => {
    if (excelFileList.length === 0) {
      message.warning("请先选择文件");
      return;
    }

    setConfirmLoading(true);

    try {
      // 添加申请时间（使用当前时间）
      const applicationDate = new Date().toISOString();
      const selectedNodes = excelForm.getFieldValue("indicator");
      const selectedIndicator = indicators
        .find((item) => item.value === selectedNodes[0])
        ?.children?.find((child) => child.value === selectedNodes[1]);
      const formData = new FormData();
      formData.append("indicator_id", values.indicator[1]);
      formData.append(
        "indicator_name",
        selectedIndicator.rawData.indicator_name
      );
      formData.append("evaluator_id", userInfo.username);
      formData.append("evaluator_name", userInfo.full_name);
      formData.append("state", "已审核");
      formData.append("evaluation_date", applicationDate);
      formData.append("file", excelFileList[0].originFileObj);

      httpUtil
        .uploadStudentEvaluationsExcel(formData, (progressEvent) => {
          const percent = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
        })
        .then((res) => {
          console.log(res);
          if (res.success) {
            message.success(`导入成功 ${res.data.successCount} 条记录`);
            if (res.data.errorCount > 0) {
              message.warning(`${res.data.errorCount} 条记录导入失败`);
              setErrors(res.data.errors || []);
            }
            setExcelFileList([]);
            getAllEvaluations();
          } else {
            message.error(res.error || "导入失败");
          }
        });
    } catch (error) {
      console.error("上传失败:", error);
      message.error("上传失败: " + (error.message || "未知错误"));
    } finally {
      setConfirmLoading(false);
    }
  };

  return (
    <div className="record-processing-container">
      {/* 状态说明Modal */}
      <Modal
        title={statusExplanation.title}
        open={showExplanation}
        onCancel={() => setShowExplanation(false)}
        footer={[
          <Button
            key="ok"
            type="primary"
            onClick={() => setShowExplanation(false)}
          >
            我知道了
          </Button>,
        ]}
        width={700}
      >
        {statusExplanation.content}
      </Modal>

      {/* 搜索和筛选区域 */}
      <Card title="评价记录处理" bordered={false}>
        <div>
          <Form
            form={searchForm}
            layout="inline"
            onFinish={handleSearch}
            style={{ marginBottom: 20 }}
          >
            <Form.Item name="student_id" label="学生ID">
              <Input placeholder="输入学生ID" allowClear />
            </Form.Item>

            <Form.Item name="indicator_name" label="评价类型">
              <Input placeholder="输入评价类型" allowClear />
            </Form.Item>

            <Form.Item name="state" label="状态" initialValue="all">
              <Select style={{ width: 120 }} onChange={handleStatusFilter}>
                <Option value="all">全部</Option>
                <Option value="草稿">草稿</Option>
                <Option value="已提交">已提交</Option>
                <Option value="已审核">已审核</Option>
                <Option value="已驳回">已驳回</Option>
                <Option value="申诉中">申诉中</Option>
                <Option value="已完成">已完成</Option>
              </Select>
            </Form.Item>

            <Form.Item>
              <Button
                type="primary"
                icon={<SearchOutlined />}
                htmlType="submit"
              >
                搜索
              </Button>
            </Form.Item>
            <Button type="primary" onClick={handleReset}>
              重置
            </Button>

            <Button
              type="primary"
              style={{ marginLeft: 10 }}
              onClick={showModal}
            >
              添加新的评价记录
            </Button>
          </Form>
        </div>
        {/* 评价记录表格 */}
        <Table
          columns={columns}
          dataSource={filteredRecords}
          rowKey="record_id"
          loading={loading}
          scroll={{ y: "calc(70vh - 180px)", x: "max-content" }}
          sticky={{
            offsetHeader: 0, // 固定表头
          }}
          size="small" // 紧凑型表格
          pagination={{
            ...pagination,
            showSizeChanger: true,
            pageSizeOptions: ["10", "20", "50", "100"],
            onChange: (page, pageSize) => {
              setPagination({ current: page, pageSize });
            },
          }}
        />
      </Card>

      {/* 编辑评价记录模态框 */}
      <Modal
        title="编辑评价记录"
        open={editModalVisible}
        onOk={handleEditSubmit}
        onCancel={() => setEditModalVisible(false)}
        confirmLoading={loading}
        width={600}
      >
        <Form form={form} layout="vertical">
          <Form.Item
            name="state"
            label="状态"
            rules={[{ required: true, message: "请选择状态" }]}
            onChange={() => {
              // 状态变化时触发分数验证
              form.validateFields(["score"]);
            }}
          >
            <Select placeholder="选择状态">
              <Option value="已提交">已提交</Option>
              <Option value="已审核">已审核</Option>
              <Option value="已驳回">已驳回</Option>
            </Select>
          </Form.Item>

          <Form.Item name="score" label="评分">
            <InputNumber
              min={0}
              max={100}
              precision={2}
              step={0.01}
              style={{ width: "100%" }}
              placeholder="请输入0-100的数字"
            />
          </Form.Item>

          <Form.Item
            name="comment"
            label="评语"
            rules={[{ required: true, message: "请输入评语" }]}
          >
            <Input.TextArea rows={4} placeholder="输入详细评语" />
          </Form.Item>
        </Form>
      </Modal>

      {/* 查看详情模态框 */}
      <Modal
        title="评价记录详情"
        open={detailModalVisible}
        onCancel={() => setDetailModalVisible(false)}
        footer={null}
        width={800}
      >
        {selectedRecord && (
          <>
            <Descriptions bordered column={1}>
              <Descriptions.Item label="记录ID">
                {selectedRecord.record_id}
              </Descriptions.Item>
              <Descriptions.Item label="学生姓名">
                {selectedRecord.student_name}
              </Descriptions.Item>
              <Descriptions.Item label="学生ID">
                {selectedRecord.student_id}
              </Descriptions.Item>
              <Descriptions.Item label="班级">
                {selectedRecord.class}
              </Descriptions.Item>
              <Descriptions.Item label="评价类型">
                {selectedRecord.indicator_name}
              </Descriptions.Item>
              <Descriptions.Item label="评分">
                {`${selectedRecord.score}分`}
              </Descriptions.Item>
              <Descriptions.Item label="状态">
                <Tag
                  color={
                    selectedRecord.state === "已提交"
                      ? "orange"
                      : selectedRecord.state === "已审核"
                      ? "blue"
                      : selectedRecord.state === "已驳回"
                      ? "red"
                      : selectedRecord.state === "申诉中"
                      ? "purple"
                      : selectedRecord.state === "已完成"
                      ? "green"
                      : "gray"
                  }
                >
                  {selectedRecord.state}
                </Tag>
              </Descriptions.Item>
              <Descriptions.Item label="评价时间">
                {new Date(selectedRecord.evaluation_date).toLocaleString()}
              </Descriptions.Item>
              <Descriptions.Item label="评语">
                {selectedRecord.comment || "无评语"}
              </Descriptions.Item>
            </Descriptions>

            {selectedRecord.material && (
              <>
                <Divider orientation="left">申请材料</Divider>
                <div style={{ display: "flex", flexWrap: "wrap", gap: "16px" }}>
                  {selectedRecord.material.files?.map((file, index) => (
                    <Card
                      key={index}
                      size="small"
                      style={{ width: 200 }}
                      cover={
                        file.type.includes("image") ? (
                          <img
                            alt={file.name}
                            src={`data:${file.type};base64,${file.data}`}
                            style={{ height: 160, objectFit: "contain" }}
                            onClick={() => {
                              setPreviewFile({
                                uid: index,
                                name: file.name,
                                url: `data:${file.type};base64,${file.data}`,
                              });
                              setPreviewVisible(true);
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              height: 160,
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                              background: "#f0f0f0",
                            }}
                          >
                            <DownloadOutlined style={{ fontSize: 32 }} />
                          </div>
                        )
                      }
                      actions={[
                        <Button
                          type="link"
                          icon={<EyeOutlined />}
                          onClick={() => {
                            setPreviewFile({
                              uid: index,
                              name: file.name,
                              url: `data:${file.type};base64,${file.data}`,
                            });
                            setPreviewVisible(true);
                          }}
                        >
                          预览
                        </Button>,
                      ]}
                    >
                      <Card.Meta
                        title={file.name}
                        description={`${(file.size / 1024).toFixed(1)} KB`}
                      />
                    </Card>
                  ))}
                </div>
              </>
            )}
          </>
        )}
      </Modal>

      {/* 添加申请Modal */}
      <Modal
        title="提交新申请"
        open={open}
        onOk={handleOk}
        onCancel={handleCancel}
        width={800}
        okText="提交"
        cancelText="取消"
        confirmLoading={comfirmLoading}
      >
        <Radio.Group
          value={addEvaluationRadioValue}
          onChange={(e) => setAddEvaluationRadioValue(e.target.value)}
        >
          <Radio value="single">单个学生评价记录添加</Radio>
          <Radio value="excel">按班级学生批量Excel添加</Radio>
        </Radio.Group>

        <div className="addusercontent">
          {addEvaluationRadioValue === "single" ? (
            <Form form={modalForm} layout="vertical" onFinish={handleSubmit}>
              <Form.Item
                label="选择评价指标"
                name="indicator"
                rules={[
                  {
                    required: true,
                    validator: (_, value) =>
                      value?.length === 2
                        ? Promise.resolve()
                        : Promise.reject("请先选择一级指标，再选择二级指标"),
                  },
                ]}
              >
                <Cascader
                  options={indicators}
                  placeholder="请选择评价指标"
                  changeOnSelect={false}
                  expandTrigger="hover"
                  displayRender={(labels, selectedOptions) => (
                    <span>
                      {selectedOptions[0]?.label} / {selectedOptions[1]?.label}
                    </span>
                  )}
                  fieldNames={{
                    label: "label",
                    value: "value",
                    children: "children",
                  }}
                />
              </Form.Item>
              <Form.Item>
                <Input.Group compact style={{ display: "flex" }}>
                  <Form.Item
                    label="被评价人班级"
                    name="class"
                    style={{ flex: 1, marginBottom: 0 }}
                    rules={[{ required: true, message: "请选择学生班级" }]}
                  >
                    <Select
                      style={{
                        width: 120,
                      }}
                      onChange={(value) => {
                        getClassStudents(value);
                      }}
                      options={classes}
                      placeholder="请选择班级"
                    />
                  </Form.Item>

                  <Form.Item
                    name="student"
                    label="被评价学生"
                    style={{ flex: 1, marginBottom: 0 }}
                    rules={[{ required: true, message: "请选择学生" }]}
                  >
                    {/* <Input placeholder="评价人姓名" style={{ width: "100%" }} /> */}
                    <Select
                      placeholder="请选择学生"
                      style={{
                        width: 150,
                      }}
                      options={students}
                    />
                  </Form.Item>
                </Input.Group>
              </Form.Item>
              <Form.Item
                name="description"
                label="申请备注"
                rules={[{ required: true, message: "请输入申请备注" }]}
              >
                <Input.TextArea rows={4} placeholder="请详细描述您的申请备注" />
              </Form.Item>

              <Form.Item label="申请时间">
                <Input value={new Date().toLocaleString()} disabled />
              </Form.Item>

              <Form.Item
                label="上传材料"
                name="files"
                rules={[{ required: false, message: "请上传申请材料" }]}
                extra="支持JPG/PNG格式，单文件不超过2MB，最多上传5个文件"
              >
                <Upload
                  fileList={fileList}
                  onChange={handleUploadChange}
                  onPreview={handlePreview}
                  onRemove={onRemove}
                  beforeUpload={beforeUpload}
                  accept="image/*"
                  listType="picture-card"
                  maxCount={5}
                >
                  {fileList.length >= 5 ? null : (
                    <div>
                      <PlusOutlined />
                      <div style={{ marginTop: 8 }}>上传图片</div>
                    </div>
                  )}
                </Upload>
              </Form.Item>
            </Form>
          ) : (
            <div style={{ padding: "20px 0" }}>
              <Form
                layout="vertical"
                form={excelForm}
                onFinish={handleExcelUpload}
              >
                <Form.Item
                  label="选择评价指标"
                  name="indicator"
                  rules={[
                    {
                      required: true,
                      validator: (_, value) =>
                        value?.length === 2
                          ? Promise.resolve()
                          : Promise.reject("请先选择一级指标，再选择二级指标"),
                    },
                  ]}
                >
                  <Cascader
                    options={indicators}
                    placeholder="请选择评价指标"
                    changeOnSelect={false}
                    expandTrigger="hover"
                    displayRender={(labels, selectedOptions) => (
                      <span>
                        {selectedOptions[0]?.label} /{" "}
                        {selectedOptions[1]?.label}
                      </span>
                    )}
                    fieldNames={{
                      label: "label",
                      value: "value",
                      children: "children",
                    }}
                  />
                </Form.Item>

                <Form.Item
                  label="被评价人班级"
                  name="class"
                  style={{ flex: 1, marginBottom: 0 }}
                  rules={[{ required: true, message: "请选择学生班级" }]}
                >
                  <Select
                    style={{
                      width: 120,
                    }}
                    // onChange={(value) => {
                    //   getClassStudents(value);
                    // }}
                    options={classes}
                    placeholder="请选择班级"
                  />
                </Form.Item>

                <Form.Item
                  label="上传Excel文件"
                  rules={[{ required: true, message: "请上传Excel文件" }]}
                >
                  <Upload
                    accept=".xlsx,.xls"
                    beforeUpload={(file) => {
                      const isExcel = [
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
                        "application/vnd.ms-excel",
                      ].includes(file.type);

                      if (!isExcel) {
                        message.error("仅支持 .xlsx 或 .xls 格式的文件");
                        return Upload.LIST_IGNORE;
                      }

                      const MAX_SIZE = 5 * 1024 * 1024;
                      if (file.size > MAX_SIZE) {
                        message.error("文件大小不能超过5MB");
                        return Upload.LIST_IGNORE;
                      }

                      // 使用回调方式确保获取最新状态
                      setExcelFileList([
                        {
                          ...file,
                          status: "done",
                          name: file.name,
                          originFileObj: file,
                        },
                      ]);
                      return false;
                    }}
                    fileList={excelFileList}
                    maxCount={1}
                    onRemove={() => setExcelFileList([])}
                  >
                    <Button icon={<UploadOutlined />}>选择Excel文件</Button>
                  </Upload>
                </Form.Item>

                {/* 错误信息显示区域 */}
                {errors.length > 0 && (
                  <div style={{ marginTop: 16 }}>
                    <Alert
                      message={`${errors.length} 条记录导入失败`}
                      type="error"
                      showIcon
                      description={
                        <div style={{ maxHeight: 200, overflow: "auto" }}>
                          {errors.map((err, i) => (
                            <p key={i}>
                              <strong>第 {err.row} 行:</strong> {err.error}
                              {err.data && (
                                <span style={{ color: "#888", marginLeft: 8 }}>
                                  (学号: {err.data.学号 || "无"})
                                </span>
                              )}
                            </p>
                          ))}
                        </div>
                      }
                    />
                  </div>
                )}

                <div style={{ marginTop: 16, color: "#666" }}>
                  <p>Excel模板要求：</p>
                  <ul>
                    <li>
                      第一行必须包含标题：学号、姓名、性别、专业、班级、分数、备注
                    </li>
                    <li>日期格式为YYYY-MM-DD</li>
                    <li>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          httpUtil
                            .downloadEvaluationExcelTemplate(
                              "evaluationRecords_template"
                            )
                            .catch(() => {
                              message.error("模板下载失败");
                            });
                        }}
                      >
                        模板下载
                      </a>
                    </li>
                  </ul>
                </div>
              </Form>
            </div>
          )}
        </div>
      </Modal>

      {/* 文件预览Modal */}
      <Modal
        open={previewVisible}
        title={previewFile?.name || "文件预览"}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
        width="80%"
        style={{ top: 20 }}
      >
        {previewFile?.url &&
          (previewFile.url.includes("image") ? (
            <img
              alt={previewFile.name}
              src={previewFile.url}
              style={{ width: "100%", maxHeight: "70vh", objectFit: "contain" }}
            />
          ) : (
            <iframe
              title="文件预览"
              src={previewFile.url}
              style={{ width: "100%", height: "70vh", border: "none" }}
            />
          ))}
      </Modal>
    </div>
  );
};
